// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3sEHA","info":"UpdateTermsInfo_info__1lv79"};